import { Card, Button, Typography, Space, Alert } from "antd";
import { EyeOutlined, RocketOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

export default function PublishSection({ config }) {
  const slug = config.seo?.slug;

  return (
    <Card bordered={false}>
      <Title level={5}>Publish Reservation Experience</Title>

      <Alert
        type={config.publish.status === "published" ? "success" : "info"}
        showIcon
        message={
          config.publish.status === "published"
            ? "This reservation experience is live"
            : "This reservation experience is in draft"
        }
        description={
          config.publish.status === "published"
            ? `Last published on ${new Date(
                config.publish.publishedAt
              ).toLocaleString()}`
            : "Changes are not visible to guests until published."
        }
        style={{ marginBottom: 20 }}
      />

      <Space direction="vertical" size="middle">
        <div>
          <Text strong>Public Booking Page</Text>
          <br />
          <Text type="secondary">
            https://{slug || "your-restaurant"}.netshine.one
          </Text>
        </div>

        <Space>
          <Button
            icon={<EyeOutlined />}
            disabled={!slug}
            onClick={() =>
              window.open(
                `https://${slug}.netshine.one`,
                "_blank"
              )
            }
          >
            Preview Live Page
          </Button>

          <Button
            type="primary"
            icon={<RocketOutlined />}
            disabled={!slug}
          >
            Publish Changes
          </Button>
        </Space>
      </Space>
    </Card>
  );
}
